// Default search values
export const searchValues = {
  bank: "",
  title: "",
  toDate: new Date(new Date().setHours(23, 59, 59, 999)),
  isPaid: "",
  project: "",
  toAmount: "",
  fromAmount: "",
  paymentType: "",
  bankAccount: "",
  donationType: "",
  affiliateUser: "",
  affiliateLink: "",
  classificationId: "",
  fromDate: new Date(new Date().setHours(0, 0, 0, 0)),
};

// Excel header cells name
export const excelHeaderCellsName = {
  "مدفوع": "isPaid",
  "اسم المتبرع": "donorName",
  "نوع الدفع": "paymentType",
  "معرف التبرع": "donationId",
  "رقم الهاتف": "phoneNumber",
  "تاريخ الإنشاء": "createdOn",
  "اسم الوسيط": "affiliateName",
  "رابط الوسيط": "affiliateLink",
  "عنوان المشروع": "projectTitle",
  "المبلغ الإجمالي": "totalAmount",
  "اسم الحساب البنكي": "bankAccountName",
  "تصنيف المشروع": "projectClassification",
  "إجمالي مبلغ التبرع": "totalDonationAmount",
};
